import { Button, ButtonProps } from "antd";
import BackIcon from "./icon/BackIcon";

const BackButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      style={{
        borderColor: "var(--login-input-muted)",
        background: " var(--login-input-bg)",
        width: "38px",
        height: "38px",
        minWidth: "38px",
        color: "var(--login-input-normal)",
      }}
      icon={
        <BackIcon
          style={{
            fontSize: "24px",
            color: "var(--login-input-normal)",
          }}
        />
      }
      {...props}
    />
  );
};

export default BackButton;
